import React from 'react';
import { WebSocketMessage } from 'react-use-websocket/dist/lib/types';

export const WSContext = React.createContext<{
  addSubscription: (subscription: string, callback: (message: WebSocketMessage) => void) => void;
  removeSubscription: (subscription: string, callback: (message: WebSocketMessage) => void) => void;
}>({
  addSubscription: () => {},
  removeSubscription: () => {},
});

export const WSConnectionStatusContext = React.createContext('Uninstantiated');
